import React from 'react';
import { reduxForm, InjectedFormProps, reset } from 'redux-form';
import { Form, Card, Button, Spin, Radio, Row } from 'antd';
import {
  FormField,
  SkeletonHOC,
  InputTypes,
  required,
  IconTypeNames,
} from 'common';
import { compose } from 'redux';

import styles from './DepOnline.module.scss';
import {
  DEP_ONLINE_FORM,
  DEP_ONLINE_FORM_INITIAL_VALUES,
} from './DepOnline.constants';
import { useDispatch, useSelector } from 'react-redux';
import { resetResults, searchDepOnline } from '.';
import { AppState } from 'store';
import { Redirect } from 'react-router-dom';
import { useAccount, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { getAccessToken } from 'common/helpers';

interface DepOnlineFormProps {
  handleSubmit: any;
  loading: boolean;
  countyHob: string;
  cityHob: string;
  formValues: any;
  valid: boolean;
}

type Props = DepOnlineFormProps & InjectedFormProps<any, DepOnlineFormProps>;

const DepOnlineForm: React.FC<Props> = ({
  loading,
  formValues,
  valid,
}: DepOnlineFormProps) => {
  const dispatch = useDispatch();

  const handleResetForm = () => {
    dispatch(resetResults());
    dispatch(reset(DEP_ONLINE_FORM));
  };

  const locations = [
    { name: 'Manhattan', value: 'NY065001000' },
    { name: 'Bronx', value: 'NY065002000' },
    { name: 'Kings', value: 'NY065003000' },
    { name: 'Queens', value: 'NY065004000' },
    { name: 'Richmond', value: 'NY065005000' },
  ];

  const login = useSelector((state: AppState) => state.login);
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  const handleSearch = (format: string) => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(searchDepOnline(formValues, format, response.accessToken));
      });
    }
  };

  if (login.user?.licenseflag == 'False') {
    return <Redirect to={`/pages/license`} />;
  }

  return (
    <Card size="small">
      <Spin spinning={loading} size="large" tip="Loading...">
        <Form layout="vertical" className="w-50">
          <FormField
            label="Please select County to search"
            name="hob"
            validate={[required]}
            inputType={InputTypes.RADIO_GROUP}
            autoFocus={true}
          >
            {locations.map((item) => (
              <Radio key={item.value} value={item.value}>
                {item.name}
              </Radio>
            ))}
          </FormField>
          <Row type="flex">
            <FormField label="Block" name="block" className={styles.input} />
            <FormField label="Lot" name="lot" />
          </Row>
          <FormField name="searchOption" inputType={InputTypes.RADIO_GROUP}>
            <Radio value="bill">DEP Bill</Radio>
          </FormField>
          {
            <p style={{ color: '#FF0000', fontWeight: 'bold' }}>
              NYC DEP is temporarily unavailable.
            </p>
          }
          <Button
            type="ghost"
            onClick={handleResetForm}
            className={styles.button}
          >
            Reset
          </Button>
          <Button
            /*disabled={loading || !valid}*/
            disabled={true}
            type="primary"
            htmlType="submit"
            icon={IconTypeNames.PDF}
            onClick={() => handleSearch('PDF')}
            className={styles.button}
          >
            Export as PDF
          </Button>
          <Button
            /*disabled={loading || !valid}*/
            disabled={true}
            type="primary"
            htmlType="submit"
            icon={IconTypeNames.WORD}
            onClick={() => handleSearch('doc')}
            className={styles.button}
          >
            Export as Word
          </Button>
          <p
            style={{ display: 'inline', color: '#40a9ff', fontWeight: 'bold' }}
          >
            *
          </p>
          <p style={{ display: 'inline' }}>Fee applied on Export</p>
          <p
            style={{ display: 'inline', color: '#40a9ff', fontWeight: 'bold' }}
          >
            *
          </p>
        </Form>
      </Spin>
    </Card>
  );
};

export default compose(
  SkeletonHOC({ initProp: 'workaround', rows: 12 }),
  reduxForm<any, DepOnlineFormProps>({
    form: DEP_ONLINE_FORM,
    initialValues: DEP_ONLINE_FORM_INITIAL_VALUES,
  }),
)(DepOnlineForm);
